export default function deleteLocalStorage() {
    localStorage.removeItem('refresh_token')
    localStorage.removeItem('user-token')
    location.reload()
}